
import { MonitorList } from './MonitorList';
import { MonitorShow } from './MonitorShow';

export default {
    list: MonitorList,
    show: MonitorShow
};
